import React from "react";
import FlodeskForm from "./flodeskBlog";

const Flowdesk = () => {
  return (
    <div>
      <h1>Welcome to My Blog</h1>
      <FlodeskForm />
    </div>
  );
};

export default Flowdesk;
